import { ValidationModel } from '../../../shared/models/validation-results/validation.model';
import { FinanceDisbursementRequestStatusTypesEnum, ProductsEnum } from '../../shared/enums/finance.enum';
import { DisbursementDigitalRequestModel } from './disbursement-digital-request.model';
import { DisbursementFuelTaxRequestModel } from './disbursement-fuel-tax-request.model';
import { DisbursementReportDataModel } from './disbursement-report-data.model';
import { DisbursementRequestCustomerAccountModel } from './disbursement-request-customer-account.model';
import { DisbursementRequestTypeModel } from './disbursement-request-type.model';

export class DisbursementRequestModel extends ValidationModel {

    // Gets or sets the id
    public id: number;

    // Gets or sets the disbursement request type identifier.
    public financeDisbursementRequestTypeId: number;

    // Gets or sets the disbursement request status type identifier.
    public financeDisbursementRequestStatusTypeId: number;

    // Gets or sets the business transaction number identifier.
    public businessTransactionNumberId: number;

    // Gets or sets the amount.
    public amount: number;

    // Gets or sets the customer identifier.
    public customerNumberId: number;

    // Gets or sets the approved date.
    public approvedDate: Date;

    // Gets or sets the approved by.
    public approvedBy: string;

    // Gets or sets the check number.
    public checkNumber: string;

    // Gets or sets the comment.
    public comment: string;

    // Gets or sets the created date.
    public createdDate: Date;

    // Gets or sets the created by.
    public createdBy: string;

    // Gets or sets the edited date.
    public editedDate: Date;

    // Gets or sets the edited by.
    public editedBy: string;

    // Gets or sets the issued date.
    public issuedDate: Date;

    // Gets or sets the issued by.
    public issuedBy: string;

    // Gets or sets the denied date.
    public deniedDate: Date;

    // Gets or sets the denied by.
    public deniedBy: string;

    // Gets or sets the disbursement report data
    public reportData: DisbursementReportDataModel;

    // Gets or sets the disbursement request customer accounts
    public customerAccounts: DisbursementRequestCustomerAccountModel[];

    // Gets or sets the disbursement digital request
    public digitalRequests: DisbursementDigitalRequestModel[];

    // Gets or sets the disbursement fuel tax request
    public fuelTaxRequests: DisbursementFuelTaxRequestModel[];

    // Gets or sets the disbursement request type
    public financeDisbursementRequestType: DisbursementRequestTypeModel;

    constructor(json?: any) {
        super(json);
        json = this.getBody();

        this.reportData = new DisbursementReportDataModel('');
        this.customerAccounts = new Array<DisbursementRequestCustomerAccountModel>();
        this.digitalRequests = new Array<DisbursementDigitalRequestModel>();
        this.fuelTaxRequests = new Array<DisbursementFuelTaxRequestModel>();

        if (json) {
            this.id = json.id;
            this.financeDisbursementRequestTypeId = json.financeDisbursementRequestTypeId;
            this.financeDisbursementRequestStatusTypeId = json.financeDisbursementRequestStatusTypeId;
            this.businessTransactionNumberId = json.businessTransactionNumberId;
            this.amount = json.amount;
            this.customerNumberId = json.customerNumberId;
            this.approvedDate = json.approvedDate;
            this.approvedBy = json.approvedBy;
            this.checkNumber = json.checkNumber;
            this.comment = json.comment;
            this.createdDate = json.createdDate;
            this.createdBy = json.createdBy;
            this.editedDate = json.editedDate;
            this.editedBy = json.editedBy;
            this.issuedDate = json.issuedDate;
            this.issuedBy = json.issuedBy;
            this.deniedBy = json.deniedBy;
            this.deniedDate = json.deniedDate;

            this.reportData = new DisbursementReportDataModel(json.reportData);
            this.financeDisbursementRequestType = new DisbursementRequestTypeModel(json.financeDisbursementRequestType);

            json.customerAccounts.forEach(item => {
                var customerAccount: DisbursementRequestCustomerAccountModel = new DisbursementRequestCustomerAccountModel(item);
                this.customerAccounts.push(customerAccount);
            });

            json.digitalRequests.forEach(item => {
                var digitalRequest: DisbursementDigitalRequestModel = new DisbursementDigitalRequestModel(item);
                this.digitalRequests.push(digitalRequest);
            });

            json.fuelTaxRequests.forEach(item => {
                var fuelTaxRequest: DisbursementFuelTaxRequestModel = new DisbursementFuelTaxRequestModel(item);
                this.fuelTaxRequests.push(fuelTaxRequest);
            });
        } else {
            this.financeDisbursementRequestStatusTypeId = FinanceDisbursementRequestStatusTypesEnum.Preparing;
            this.fuelTaxRequests.push(new DisbursementFuelTaxRequestModel(''));
        }
    }

    /**
     * Sets the amount based on the rate and the gallons entered. Can only be set automatically for fuel tax requests.
     */
    public setAmount() {
        if (this.fuelTaxRequests.length > 0) {
            this.amount = 0;

            if (this.fuelTaxRequests[0].fuelTaxRequestProducts.length > 0) {
                this.fuelTaxRequests[0].fuelTaxRequestProducts.forEach(product =>
                    this.amount = product.productId == ProductsEnum.LUFDORUseTax ? this.amount - product.amount : this.amount + product.amount
                );
            }

            this.amount = +((this.amount).toFixed(2));
        }
    }
}
